import React from 'react'
import { Seo } from '~/components/molecules/Seo'
import { Props, Screen } from '~/components/screens/press'
import { site } from '~/config'
import { GetStaticProps } from 'next'
import { getAllPressReleases } from '~/services/PressReleaseService'
import { serialize } from 'next-mdx-remote/serialize'

const Page = (props: Props) => (
  <>
    <Seo title={`Press | ${site.title}`} />
    <Screen {...props} />
  </>
)

export default Page

export const getStaticProps: GetStaticProps<Props> = async () => {
  const sortedPressReleases = getAllPressReleases().sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  )
  const featurePressRelease = sortedPressReleases[0]
  const truncatedMarkdown = truncateMarkdown(featurePressRelease.markdown, 240)
  const featurePressReleaseMdx = await serialize(truncatedMarkdown)
  delete featurePressRelease.markdown
  // Filter out the first press release from the list since it is "feature" instead
  const pressReleases = sortedPressReleases
    .filter((pr, i) => i !== 0)
    .map((pr) => ({
      title: pr.title,
      slug: pr.slug,
    }))
  return {
    props: {
      featurePressRelease,
      featurePressReleaseMdx,
      pressReleases,
    },
  }
}

function truncateMarkdown(markdown: string, maxLength: number): string {
  let truncated = ''
  let length = 0
  let inLink = false

  const paragraphs = markdown.split(/\n{2,}/)

  for (const paragraph of paragraphs) {
    if (length + paragraph.length + 2 > maxLength) {
      const words = paragraph.split(/\s+/)
      for (const word of words) {
        if (word.startsWith('[')) {
          inLink = true
        }
        if (word.endsWith(']')) {
          inLink = false
        }

        if (length + word.length + 1 > maxLength && !inLink) {
          return truncated.trim() + '...'
        }

        truncated +=
          (truncated && !truncated.endsWith('\n\n') ? ' ' : '') + word
        length += word.length + 1
      }
    } else {
      truncated += paragraph + '\n\n'
      length += paragraph.length + 2
    }

    if (length >= maxLength) {
      break
    }
  }

  return truncated.trim() + (truncated.length < markdown.length ? '...' : '')
}
